import React, { Fragment, useState, useEffect } from 'react';
import CustomTable from '@jumbo/components/CustomTable';
import PageLoader from '@jumbo/components/custom/Spinner/pageLoader';
import VerReclamo from '../../AppComponentsNUtils/ModalVerReclamo';
import AddAntecedente from '../../AppComponentsNUtils/AddAntecedente';
import AddRecurso from '../../AppComponentsNUtils/AddRecurso';
import GetReclamo from '../../AppComponentsNUtils/GetReclamo';
import { API_EXTRANET } from 'config/config';
import { validacionPermit } from '../../../../../services/service.user';
import axios from 'axios';
import { CustomToast, toast } from '@jumbo/components/custom/Toast';
import Spinner from '@jumbo/components/custom/Spinner';
import {
  getDatosEntidadesList,
  tableHeadCells,
  validaciones,
  todosLosReclamosActions,
} from '../../AppComponentsNUtils/SeguimientoReclamosUtils';
import ModalProrroga from '../../AppComponentsNUtils/ModalProrroga';
import RenderFile from 'customComponents/RenderFile';
import { getDataSeguimientoTableNetwork, getNetworkMembers } from 'services/api';

const TablaReclamosTodos = () => {
  const [primeraCarga, setPrimeraCarga] = useState(false);
  const [entidadesList, setEntidadesList] = useState([]);
  const [showVerReclamo, setShowVerReclamo] = useState(false);
  const [reclamoVer, setReclamoVer] = useState(null);
  const [showAddAnt, setShowAddAnt] = useState(false);
  const [reclamoAddAnt, setrReclamoAddAnt] = useState(null);
  const [showAddRec, setShowAddRec] = useState(false);
  const [reclamoAddRec, setrReclamoAddRec] = useState(null);
  const [showAutoAsignarReclamo, setShowAutoAsignarReclamo] = useState(false);
  const [reclamoAutoAsignar, setReclamoAutoAsignar] = useState(null);
  const [spinner, setSpinner] = useState(false);

  const [showPreview, setShowPreview] = useState(false);

  const [showProrroga, setShowProrroga] = useState(false);
  const [reclamoProrroga, setReclamoProrroga] = useState(null);
  const [showPreviewSuper, setShowPreviewSuper] = useState(false);
  const [url, setUrl] = useState(undefined);
  const [urlSuper, setUrlSuper] = useState(undefined);
  const [reload, setReload] = useState(false);

  const loadEntidades = () => {
    const user = JSON.parse(sessionStorage.getItem('user'));

    if (user.is_network) {
      if (user.organization.network_id) {
        getNetworkMembers(user.organization.network_id)
          .then(resNet => {

            const entidadesQueryString = resNet.data.members
              .map(item => `entidades=${item.name}`)
              .join('&')

            getDataSeguimientoTableNetwork('&indice=reclamos_ip', entidadesQueryString)
              .then(res => {
                setEntidadesList(
                  res.data.map((entidad, index) => {
                    return getDatosEntidadesList(entidad);
                  }),
                );
                setPrimeraCarga(true);
              })
              .catch(err => {
                toast.error('Ocurrió un error al buscar reclamos pendientes.');
                console.log(err);
              })
              .finally(f => {
                setSpinner(false);
              });

          })
          .catch(error => {
            toast.error('Ocurrió un error al buscar los datos de la red.');
            console.error(error)
          })
          .finally(fin => {

          })
      } else {
        toast.error("El usuario está configurado como un usuario de red, por favor contactar con administrador.")
        setPrimeraCarga(true)
        setSpinner(false)
      }

    } else {
      axios
        // eslint-disable-next-line
        .get(`${API_EXTRANET}api/v1/reclaim_ip?entidad=${user.organization.name}` + '&indice=reclamos_ip', {
          headers: {
            Authorization: `Bearer ${JSON.parse(sessionStorage.getItem('user')).token}`,
          },
        })
        .then(res => {
          setEntidadesList(
            res.data.map(entidad => {
              return getDatosEntidadesList(entidad);
            }),
          );
          setSpinner(false);
          setPrimeraCarga(true);
        })
        .catch(err => {
          setSpinner(false);
          console.log(err);
          toast.error('Ocurrió un error al buscar reclamos.');
        });
    }


  };

  useEffect(() => {
    /* const user = JSON.parse(sessionStorage.getItem('user')); */
    axios
      .get(`${API_EXTRANET}api/v1/etapas_ip`, {
        headers: {
          Authorization: `Bearer ${JSON.parse(sessionStorage.getItem('user')).token}`,
        },
      })
      .then(res => {
        loadEntidades();
      })
      .catch(err => {
        toast.error('Ocurrió un error al cargar el filtro de etapas.');
        console.log(err);
      });
  }, [reload]);

  const handleAction = (menu, item) => {
    if (menu.action === 'ver') {
      setReclamoVer(item);
      setShowVerReclamo(true);
    } else if (menu.action === 'addAnt') {
      setrReclamoAddAnt(item);
      setShowAddAnt(true);
    } else if (menu.action === 'addRec') {
      setrReclamoAddRec(item);
      setShowAddRec(true);
    } else if (menu.action === 'autoAsignar') {
      setReclamoAutoAsignar(item);
      setShowAutoAsignarReclamo(true);
    } else if (menu.action === 'prorroga') {
      setReclamoProrroga(item);
      setShowProrroga(true);
    }
  };

  const openModal = fila => {
    setReclamoVer(fila);
    setShowVerReclamo(true);
  };

  const verReclamoClose = () => {
    setShowVerReclamo(false);
    setReclamoVer(null);
  };

  const AddAntClose = () => {
    setrReclamoAddAnt(null);
    setShowAddAnt(false);
  };

  const AddRecClose = () => {
    setrReclamoAddRec(null);
    setShowAddRec(false);
  };

  const autoAsignarReclamoSubmit = () => {
    setShowAutoAsignarReclamo(false);
    setReclamoAutoAsignar(null);
    setSpinner(true);
    loadEntidades();
  };

  const autoAsignarReclamoClose = () => {
    setShowAutoAsignarReclamo(false);
    setReclamoAutoAsignar(null);
  };

  const closeModalProrroga = () => {
    setShowProrroga(false);
    setReclamoProrroga(null);
  };

  const closePreview = () => {
    setShowPreview(false);
    setUrl('');
  };

  const cargarUrl = url => {
    setUrl(url);
    setShowPreview(true);
  };

  const closePreviewSuper = () => {
    setShowPreviewSuper(false);
    setUrlSuper('');
  };
  const cargarUrlSuper = url => {
    setUrlSuper(url);
    setShowPreviewSuper(true);
  };

  return (
    validacionPermit('search_reclaim_ip') && (
      <Fragment>
        <Spinner show={spinner} />
        <CustomToast />
        <VerReclamo
          openDialog={showVerReclamo}
          close={verReclamoClose}
          reclamo={reclamoVer}
          cargarPreview={cargarUrl}
          cargarPreviewSuper={cargarUrlSuper}
        />
        <AddAntecedente
          openDialog={showAddAnt}
          close={AddAntClose}
          reclamo={reclamoAddAnt}
          cargarPreview={cargarUrl}
          cargarPreviewSuper={cargarUrlSuper}
          setReload={setReload}
          reload={reload}
        />
        {showPreview ? <RenderFile openDialog={showPreview} url={url} close={closePreview} /> : null}
        {showPreviewSuper ? <RenderFile openDialog={showPreviewSuper} url={urlSuper} close={closePreviewSuper} /> : null}

        <AddRecurso openDialog={showAddRec} close={AddRecClose} reclamo={reclamoAddRec} />
        <ModalProrroga
          openDialog={showProrroga}
          close={closeModalProrroga}
          reclamo={reclamoProrroga}
          reload={reload}
          setReload={setReload}
        />
        <GetReclamo
          openDialog={showAutoAsignarReclamo}
          close={autoAsignarReclamoClose}
          reclamo={reclamoAutoAsignar}
          submit={autoAsignarReclamoSubmit}
        />

        {primeraCarga ? (
          entidadesList.length === 0 ? (
            <h1>No hay reclamos</h1>
          ) : (
            <CustomTable
              headCells={tableHeadCells}
              rows={entidadesList}
              title={'Reclamos'}
              validation={validaciones}
              search={true}
              actions={todosLosReclamosActions}
              handleAction={handleAction}
              openModal={openModal}
            />
          )
        ) : (
          <PageLoader />
        )}
      </Fragment>
    )
  );
};

export default TablaReclamosTodos;
